import { render, staticRenderFns } from "./CategorySearchMeta.vue?vue&type=template&id=945df866&"
import script from "./CategorySearchMeta.vue?vue&type=script&lang=js&"
export * from "./CategorySearchMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/juhani/ddev/aidian-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('945df866', component.options)
    } else {
      api.reload('945df866', component.options)
    }
    module.hot.accept("./CategorySearchMeta.vue?vue&type=template&id=945df866&", function () {
      api.rerender('945df866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/CategorySearchMeta.vue"
export default component.exports